<template>
  <div class="modal-view-notification">
    <div class="modal-head">
      <h4>REQUESTS DETAILS</h4>
      <a href="javascript:;" class="close" @click="$emit('close')"></a>
    </div>

    <div class="modal-body">
      <ul class="details">
        <li class="form-row">
          <label class="lb">DATE</label>
          <div class="inputs">{{ request.request_date | toHumanDate('DD.MM.YYYY') }}</div>
        </li>
        <li class="form-row">
          <label class="lb">COMPANY</label>
          <div class="inputs">{{ request.client.name }}</div>
        </li>
        <li class="form-row">
          <label class="lb">CONTACT</label>
          <div class="inputs">{{ request.contact?request.contact.full_name:'' }}</div>
        </li>
        <li class="form-row">
          <label class="lb">JOB TITLE</label>
          <div class="inputs">{{ request.name }}</div>
        </li>
        <li class="form-row">
          <label class="lb">DESCRIPTION</label>
          <div class="inputs" v-html="request.description"></div>
        </li>
        <li v-if="request.files.length > 0" class="form-group">
          <label class="lb">ATTACHMENTS</label>
          <ul>
            <li v-for="(file, index) in request.files" :key="index">
              <a target="_blank" :href="file.download_url">{{ file.name }}</a>
              &nbsp;&nbsp;&nbsp;
              <a class="text-danger small" @click="removeAttachment(file)" href="javascript:;">remove</a>
            </li>
          </ul>
        </li>
      </ul>

      <div v-if="request.status != 'pending'">
        <br/>
        <h5>This request is {{ request.status }}.</h5>
      </div>
      <!--
      <div class="documents">
        <a href="#" class="icon-square-down"></a>
        <h4>BRIEF/FILES</h4>
        <ul>
          <li v-for="m in 3" :key="m">
            <a href="#" target="_blank">Document name here.pdf</a>
            <a v-if="false" href="javascript:;" v-tooltip="'Delete attachment'"><span class="icon-trash"></span></a>
          </li>
        </ul>
      </div>
      -->
    </div>
    <div class="modal-foot">
      <div class="btns btns-2">
        <beat-loader v-if="state == 'saving'"></beat-loader>
        <template v-else>
          <button v-if="request.status == 'pending'" type="button" class="btn btn-outline-black" @click="createQuote">Create Quote</button>
          <button v-if="request.status == 'pending'" type="button" class="btn btn-outline-black" @click="rejectRequest">Reject</button>
          <button v-if="request.status == 'cancelled'" type="button" class="btn btn-outline-danger" @click="deleteRequest">Delete</button>
          <button type="button" class="btn btn-outline-gray" @click="$emit('close')">Close</button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import ServiceJobRequest from '@/services/jobrequest'
  import BeatLoader from 'vue-spinner/src/BeatLoader'

export default {
  components: {
    BeatLoader,
  },
  data () {
    return {
      state: ''
    }
  },
  props: ['request', 'idx'],
  watch: {},
  computed: {},
  created () {},
  mounted () {},
  methods: {
    init () {

    },
    createQuote () {
      let self = this;
      if ( self.state == 'saving' ) {
        return;
      }
      self.state = 'saving';
      ServiceJobRequest.createQuote(self.request.id, data => {
        self.state = '';
        if (data.status == 'FAILED') {
          self.$notify({
            type: 'error',
            text: data.error
          });
        } else {
          self.$notify({
            type: 'success',
            text: 'Quote for this request have been created.'
          });
          self.$emit('close');
          self.$router.push({
            name: 'quote',
            params: {
              quoteId: data.result.id
            }
          });
        }
      });
    },
    rejectRequest() {
      let self = this;
      if ( self.state == 'saving' ) {
        return;
      }
      self.state = 'saving';
      ServiceJobRequest.save(self.request.id, {status: 'cancelled'}, data => {
        self.state = '';
        self.$notify({
          type: 'success',
          text: 'The request has been rejected.'
        });
        self.$store.dispatch('GET_NOTIFICATIONS');
        self.$parent.$emit('on-rejected', data);
        self.$emit('close');
      });
    },
    deleteRequest() {
      let self = this;
      if ( self.state == 'saving' ) {
        return;
      }
      self.$dialog
        .confirm('Are you sure you want to delete this request?', {
          html: true,
          loader: true,
          okText: "Yes, I'm sure",
          cancelText: "Cancel",
        })
        .then(dialog => {
          self.state = 'saving';
          ServiceJobRequest.delete(self.request.id, data => {
            dialog.close();
            self.state = '';
            self.$notify({
              type: 'success',
              text: 'The request has been deleted.'
            });
            self.$parent.$emit('on-deleted', data);
            self.$emit('close');
          });
        })
        .catch(() => {
        });
    },
    removeAttachment(file) {
      let self = this, msg = 'Are you sure you want to delete this attachment?';
      self.$dialog.confirm( msg, {
        html: true,
        loader: true,
        okText: "Yes, I'm sure",
        cancelText: "Cancel",
      } )
        .then(dialog => {
          ServiceJobRequest.deleteAttachment(self.request.id, file.id, (result) => {
            dialog.close();
            if (result.status == 'SUCCESS') {
              self.$notify({
                type: 'success',
                text: 'The attachment is deleted'
              });
              self.request.files = result.request.files;
            } else {
              self.$notify({
                type: 'error',
                title: 'Invalid Request',
                text: result.error,
              });
            }
          });
        })
        .catch(() => {})
    }
  }
}
</script>
